<template>
  <dd-pill :color="cellProps.color">
    {{ cellProps.description }}
  </dd-pill>
</template>

<script>
export default {
  name: "Status.vue",
  props: {
    cellProps: {
      description: {
        type: String,
        required: true,
      },
      color: {
        type: String, required: true,
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
.status {
  padding: $spacing-xxs;
  font-weight: bold;
  border-radius: $border-radius-small;
  color: white;
  font-size: .65em;
  text-transform: uppercase;
  letter-spacing: .05em;
}
</style>
